import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableNoteSemUn from "./DataTableNoteSemUn"
import AddNoteLibre from "./AddNoteLibre"
import DataTableNoteSemDeux from "./DataTableNoteSemDeux"

const Note = props => {
  const [section, setSection] = useState(1)
  var url = window.location.href
  var array = url.split("/")
  var id = array[4]

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableNoteSemUn type={id} />
    } else if (section === 2) {
      return <DataTableNoteSemDeux type={id} />
    } else if (section === 3) {
      return <AddNoteLibre setSection={setSection} type={id} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> {props.t("Note")}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Note semestre 1")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Note semestre 2")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 3,
                  })}
                  onClick={() => {
                    setSection(3)
                  }}
                >
                  {props.t("Ajouter note libre")}
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(Note))
Note.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
